export const calculateTotalCount = (data) => {
  if (Array.isArray(data)) {
    return data.reduce((total, item) => total + item.countitems, 0);
  } else {
    console.log('Fetched data is not an array:', data);
    return 0;
  }
};